import { render, staticRenderFns } from "./wjAppointmentEdit.vue?vue&type=template&id=70e7a60e&"
import script from "./wjAppointmentEdit.vue?vue&type=script&lang=js&"
export * from "./wjAppointmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./wjAppointmentEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports